export default function changeAppChoiceViewAction(context, payload, done) {
    context.dispatch('APP_CHOICE_VIEW_CHANGED', payload);
    done();
}
